import { Injectable } from '@angular/core';

import { CommonRequestService, PagingParam } from './common-request.service';
import { UserService } from './user.service';

import { AppSettings } from './../app.settings';
import { Gfo } from './gfo.service';

@Injectable()
export class RequestTableService {

	constructor(
		private requestService: CommonRequestService,
		private userService: UserService
	) { }

  	tableGet(tab: string, returnedColumn?: string, gfo?: Gfo, paging?: PagingParam, distinct?: boolean) {
		const params: any = {
			tab: tab
		};
		if (returnedColumn) {
			params.column = returnedColumn;
		}
		if (gfo) {
			params.gfo = JSON.stringify(gfo);
		}
		if (paging) {
			this.requestService.setParamsPaging(params, paging);
		}
		if (distinct || distinct === false) {
			params.distinct = distinct.toString();
		}
		return new Promise((resolve, reject) => {
			this.requestService.requestGet(AppSettings.serviceRootUrl + 'common/table', {
				params: params
			}, rsp => resolve(rsp), err => reject(err));
		});
	}
	tablePost() {

	}
	tablePut(gto, sessionType, description?, successCallback?, errorCallback?) {
		const url = AppSettings.serviceRootUrl + 'common/table';
		const body = {
			application: AppSettings.appName,
			userId: this.userService.getUserInfo().userId,
			gto: JSON.stringify(gto),
			sessionType: sessionType,
			sessionDescription: description ? description : 'description'
		};
		this.requestService.requestPut(url, body, successCallback, errorCallback);
	}
}
